export default "__VITE_PUBLIC_ASSET__0d30aa8c__"